import classNames from 'classnames';
import React from 'react';

import useResponsive, { breakpoints } from '../../../hooks/useResponsive';
import { Dropdown, DropdownButton, DropdownMenu } from '../Dropdown/Dropdown';
import Icon from '../Icon/Icon';
import WpImage, { imgSizes } from '../WpImage/WpImage';
import * as styles from './Image.module.scss';

const Image = ({
  className,
  image,
  caption,
  isPrimary,
  isBreakout,
  size = [
    { size: imgSizes.PORTRAIT_SMALL },
    {
      size: isBreakout ? imgSizes.LETTERBOX_XLARGE : imgSizes.LETTERBOX_MEDIUM,
      media: `(min-width: ${breakpoints.medium}px)`,
    },
  ],
  ...other
}) => {
  const { isXSmall } = useResponsive();

  const classname = classNames(
    styles.container,
    {
      [ styles.isPrimary ]: isPrimary,
      [ styles.isBreakout ]: isBreakout,
    },
    className
  );

  const imgCaption = (caption || image?.caption)?.replace(/(<([^>]+)>)/gi, "");

  return image ? (
    <figure {...other} className={classname}>
      <div className={styles.img}>
        <WpImage {...image} size={size} />
      </div>
      {imgCaption && (
        <figcaption className={styles.caption}>
          {isXSmall ? (
            <div className={styles.dropdown}>
              <Dropdown>
                <DropdownButton
                  className={styles.dropdownToggle}
                  aria-label="Toggle caption"
                >
                  <Icon name="camera" />
                </DropdownButton>
                <DropdownMenu align="top-left">
                  {imgCaption}
                </DropdownMenu>
              </Dropdown>
            </div>
          ) : (
            <span className={styles.label}>
              <Icon name="camera" />
              {imgCaption}
            </span>
          )}
        </figcaption>
      )}
    </figure>
  ) : null;
};

export default Image;
